import { DatePipe } from '@angular/common';
import { Component, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DateFilters, NameFilter } from '../../interface/data.interface';

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss'],
  providers: [DatePipe],
})
export class FiltersComponent {
  @Output() onEnter: EventEmitter<DateFilters> = new EventEmitter();
  @Output() geFilter: EventEmitter<NameFilter> = new EventEmitter();
  public formFilter!: FormGroup;

  constructor(private fb: FormBuilder) {
    this.formFilter = this.fb.group({
      start: [''],
      end: [''],
      generalFilter: [''],
    });
  }

  filtrarPorFecha() {
    const endDate = this.formFilter.controls['end']?.value;
    const startDate = this.formFilter.controls['start']?.value;

    const startDateMillis = startDate ? startDate.valueOf() : null;
    const endDateMillis = endDate ? endDate.valueOf() : null;

    const filtersDate: DateFilters = {
      dateEnd: endDateMillis,
      dateStart: startDateMillis,
    };

    this.onEnter.emit(filtersDate);
  }

  filtroGeneral(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    const generalFilter = this.formFilter.controls['generalFilter']?.value;

    const general: NameFilter = {
      nameCompany: filterValue,
    };

    this.geFilter.emit(general);
  }

}
